import slotTag from './slots/index'
import middleware from './middleware/index'

const mountSlotFlies = (h, conf, children) => {
    const childObjs = slotTag[conf.__config__.tag]
    if (childObjs) {
        Object.keys(childObjs).forEach(key => {
            const childFunc = childObjs[key]
            if (conf.__slot__ && conf.__slot__[key]) {
                children.push(childFunc(h, conf, key))
            }
        })
    }
}

function emitEvents(conf) {
    // 如果conf里有 on, nativeOn的属性
    ['on', 'nativeOn'].map(key => {
        const eventKeyList = Object.keys(conf[key] || {})
        eventKeyList.map(item => {
            //取到on, nativeOn属性的函数名
            const val = conf[key][item]
            if (typeof val === 'string') {
                if (item === 'input') {
                    // 如果监听了input事件 会把组件本身的input事件覆盖掉，这里input做特殊处理（保证组件本身input逻辑正常）
                    conf[key][item] = event => {
                        this.$emit('input', event)
                        this.$emit(val, event)
                    }
                } else {
                    // 子组件调用的时候触发父组件Parser的绑定的监听（methods中的函数）
                    conf[key][item] = event => this.$emit(val, event)
                }
            }
        })
    })
}

function buildDataObject(conf, dataObject) {
    Object.keys(conf).map(key => {
        const val = conf[key]
        // 如果formData中有值就用form中的值，没有再用默认值
        const defaultValue = this.info[conf.__vModel__] || conf.__config__.defaultValue
        if (key === '__vModel__') {
            // 实现要挂载组件（input、select等）的v-model, 并通知父组件
            vModel.call(this, dataObject, defaultValue)
        } else if (dataObject[key]) {
            // 监听除input之外 conf.on中自定义函数, style属性
            dataObject[key] = { ...dataObject[key], ...val }
        } else {
            // 剩余的作为原生标签属性
            dataObject.attrs[key] = val
        }
    })
    // element组件特殊处理
    Object.keys(middleware).map(key => {
        // 如有特殊处理的el-tag
        if (key === conf.__config__.tag) {
            const { attrs, on, props } = middleware[key].call(this, conf, dataObject.props.value)
            dataObject.attrs = Object.assign(dataObject.attrs, attrs)
            dataObject.on = Object.assign(dataObject.on, on)
            dataObject.props = Object.assign(dataObject.on, props)
        }
    })
}

function vModel(dataObject, defaultValue) {
    if (defaultValue) dataObject.props.value = defaultValue

    // 触发父组件中buildListeners中监听的input方法改变表单值
    dataObject.on.input = val => {
        this.$emit('input', val)
    }
}

export default {
    props: {
        conf: {
            type: Object,
            required: true
        },
        info: {
            type: Object,
            default: () => { }
        }
    },
    render(h) {
        // 重新定义属性
        const dataObject = {
            // 第一版暂时通过props的option属性传递， 后续改为读根目录的配置文件，先读再取props.option然后合并。
            attrs: { ...this.$attrs, formData: this.info },
            props: {},
            nativeOn: {},
            on: {},
            style: {}
        }
        const conf = JSON.parse(JSON.stringify(this.conf))
        const children = this.$slots.default || []
        // 挂slot元素 和 子组件
        mountSlotFlies.call(this, h, conf, children)
        // 挂config on属性中的监听函数
        emitEvents.call(this, conf)

        buildDataObject.call(this, conf, dataObject)
        return h(this.conf.__config__.tag, dataObject, children)
    }
}